import React, { Component } from "react";
import ReactDom from 'react-dom';
import Link from "gatsby-link";

import SideSpacing from '../HOC/sidespacing';

class Contact extends Component {

handleHover = e => {
    const bg = document.getElementById("contact");
    e.preventDefault();
    bg.classList.toggle("bg-pink");
};

handleScroll = e => {
    const paget = document.getElementById("contact").getBoundingClientRect().top;
    const pageb = document.getElementById("contact").getBoundingClientRect().bottom;
    const sh = screen.height;

    if (paget < sh) {
        if (screen.width > 768) {
            if (paget < sh-200) {
                this.props.onMenuToggleWhite(true);
            } else {
                this.props.onMenuToggleWhite(false);
            }
            if (paget < 80+24) {
                this.props.onLogoWhite(true);
            } else {
                this.props.onLogoWhite(false);
            }
        }
    }
};

componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
}

componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
}

render (props) {

return (

<div id={this.props.id} className="flex flex-col items-end w-screen min-h-screen bg-black pin-l overflow-hidden -ml-6
md:flex-row md:w-auto md:-mr-6">

    <SideSpacing />

    <div className="flex flex-col flex-1 h-auto w-full overflow-hidden justify-end textin msb px-6
    md:flex-row md:flex-wrap md:pl-6 md:mb-0 md:ml-6">

        <div className="w-full mst msb pst md:mt-0"/>

        <div className="w-full pst psb">
            <div className="txtheader leading-none font-light text-white">
                <h1 className="font-light">Let's collaborate<br/><a className="no-underline text-white" onMouseOver={this.handleHover} onMouseOut={this.handleHover} href="mailto:hello@idpo.co">↗︎ hello@idpo.co</a></h1>
            </div>
        </div>

        <div className="flex flex-col h-full w-full msb
        md:flex-row md:h-auto">

            <div className="pt-1 pb-2 txtbody leading-loose font-bold
            md:w-2/5 md:leading-normal">
                <p></p>
            </div>

            <div className="txtbody leading-normal font-normal msb text-white
            md:mb-0 md:w-3/5 md:pt-1 md:pr-2">
                <p>We’d love to discuss your venture and how we can work together. We collaborate with startups and progressive organisations, as well as other studios, artists and engineers.
                    <br/><a className="no-underline text-white" onMouseOver={this.handleHover} onMouseOut={this.handleHover} href="https://www.medium.com/@idprojectoffice">↪︎ Read our Medium posts on project insights.</a>
                    <br/><a className="no-underline text-white" onMouseOver={this.handleHover} onMouseOut={this.handleHover} href="https://www.twitter.com/idProjectOffice">↪︎ Follow us on Twitter</a>.</p>
            </div>

        </div>

        <div className="flex flex-col h-full w-full
        md:flex-row md:h-auto">

            <div className="pt-1 pb-2 txtbody leading-loose font-bold
            md:w-2/5 md:leading-normal">
                <p></p>
            </div>

            <div className="txtbody leading-normal font-normal msb text-white
            md:mb-6 md:w-3/5 md:pt-1 md:pr-2">
                <p>© id Project Office Ltd. 2018.
                <br/>Company no. 11309624 registered in England & Wales</p>
            </div>

        </div>

    </div>


    <SideSpacing />

</div>

)
};

};

export default Contact;


// WEBPACK FOOTER //
// ./src/components/ContactPage/contact.js